"use client"

import { Pipette } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `PipetteIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const PipetteIcon = component(Icon)({ as: Pipette })
